import React, {Component} from 'react';
import {connect} from 'react-redux';
// components
import {HARD_SUSPENDED, NMB, PRE, RES, SOFT_SUSPENDED, VID} from './../../../constants/identifiers';
import {getAllWrappedBets} from './../helpers/betHelpers';
import {Overlay} from './../components/overlay';
import ActiveBetsSummary from './../components/activeBetsSummary';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        betHistoryBets: state.vpp.betHistoryBets,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        channelEventBets: state.vpp.channelEventBets,
        systemLanguage: state.vpp.systemLanguage
    };
};

class OverlayContainer extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            games: storeData.vpp.games,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            betHistoryBets: storeData.vpp.betHistoryBets,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            channelEventBets: storeData.vpp.channelEventBets,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                games: storeData.games,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                betHistoryBets: storeData.vpp.betHistoryBets,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                channelEventBets: storeData.vpp.channelEventBets,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];

        let overlayType;
        let betSummaryOverlay;
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let eventBets;
        if (selectedEvent) {
            eventBets = getAllWrappedBets(this.state, selectedEvent.channel).filter(
                (pBet) => pBet.Bets[0].EventId === selectedEvent.eventId.toString() && pBet.Bets[0].Channel === selectedEvent.channel
            );
        }

        if (selectedEvent && !this.props.showLoadingOverlay) {
            for (let i = 0; i < storeData.vpp.noMoreBetsEventList.length; i++) {
                if (storeData.vpp.noMoreBetsEventList[i].eventId === selectedEvent.eventId && storeData.vpp.noMoreBetsEventList[i].gameChannel === selectedGame.channel) {
                    if (selectedGame.controllerState === PRE || selectedGame.controllerState === NMB) {
                        overlayType = 'NMB';
                    } else if (selectedGame.controllerState === VID || selectedGame.controllerState === RES) {

                        if (eventBets && eventBets.length > 0) {
                            betSummaryOverlay = (<ActiveBetsSummary store={this.props.store} activeBets={eventBets}/>);
                        } else {
                            overlayType = 'LIVE';
                        }
                    }
                    break;
                }
            }
        }

        if (selectedEvent && !this.props.showLoadingOverlay) {
            if (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === HARD_SUSPENDED ||
                (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === SOFT_SUSPENDED && betSummaryOverlay === undefined)) {
                overlayType = 'GAME_DISABLED';
            }
        }

        let overlay;
        if (this.props.showLoadingOverlay) {
            overlayType = 'LOADING';
        }

        if (betSummaryOverlay) {
            overlay = betSummaryOverlay;
        } else {
            overlay = <Overlay store={this.props.store} overlayType={overlayType}/>;
        }

        return overlay;
    }
}

export default connect(mapStateToProps)(OverlayContainer);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/overlayContainer.js